import type {TMediaLibraryScope} from "@/store/types";

const scopeParam = ({agencyId, companyId}: TMediaLibraryScope) =>
  agencyId ? `agency_id=${agencyId}` : `company_profile_id=${companyId}`;

export const MEDIA_LIBRARY_KEYS = {
  qMediaLibrary: ({agencyId, companyId, params}: TMediaLibraryScope & {params?: string | null}) => [
    `/media_library/?${scopeParam({agencyId, companyId})}${params ? `&${params}` : ""}`,
  ],
  qMediaLibraryCampaigns: ({agencyId, companyId, params}: TMediaLibraryScope & {params?: string | null}) => [
    `/media_library/campaigns/?${scopeParam({agencyId, companyId})}${params ? `&${params}` : ""}`,
  ],
  qMediaLibraryStats: ({agencyId, companyId, params}: TMediaLibraryScope & {params?: string | null}) => [
    `/media_library/stats/?${scopeParam({agencyId, companyId})}${params ? `&${params}` : ""}`,
  ],
} as const;
